import React from 'react';
import PropTypes from 'prop-types';
import WidgetSize from 'components/WidgetSize';

const CrudWidgetSize = ({ input, ...props }) => {
    const { onChange } = input;

    return <WidgetSize onChange={onChange} value={input.value} input={input} {...props} />;
};

CrudWidgetSize.propTypes = {
    input: PropTypes.shape({}).isRequired,
};

export default CrudWidgetSize;
